module.exports = __webpack_public_path__ + "img/curved14.0123bfe4.jpg";